import type { Role } from "@/api/types";

/**
 * The role ladder (#230), mirroring core/src/auth/role-rank.ts: owner ≥ admin ≥ operator.
 * UI gating is rank-based so owner sees every admin surface; the API enforces independently.
 */
const ROLE_RANKS: Record<Role, number> = { operator: 1, admin: 2, owner: 3 };

function rankOf(role: string): number {
  return ROLE_RANKS[role as Role] ?? 0;
}

/** Rank comparison: an unknown role never satisfies anything (fail-closed). */
export function roleAtLeast(actual: string, required: Role): boolean {
  return rankOf(actual) >= ROLE_RANKS[required] && rankOf(actual) > 0;
}

/** i18n key for the role label shown in the shell header. */
export function roleLabelKey(role: string): "role.owner" | "role.admin" | "role.operator" {
  if (role === "owner") return "role.owner";
  if (role === "admin") return "role.admin";
  return "role.operator";
}
